export const LEADERBOARD_PAGE_SIZE = 50;
